/**
 * Theme Configuration
 * Generated by Orbital Compiler
 *
 * Import this file and pass to ThemeProvider:
 *
 * ```tsx
 * import { THEMES, DEFAULT_THEME } from './generated/theme-config';
 * import { ThemeProvider } from '@almadar/ui/context';
 *
 * <ThemeProvider themes={THEMES} defaultTheme={DEFAULT_THEME}>
 *   <App />
 * </ThemeProvider>
 * ```
 */

import type { UIThemeDefinition } from '@almadar/ui/providers';

/** Theme definitions for ThemeProvider */
export const THEMES: UIThemeDefinition[] = [
  { name: 'almadar', displayName: "Almadar", hasLightMode: true, hasDarkMode: true },
];

export type ThemeName = 'almadar';

/** Default theme from orbital schema */
export const DEFAULT_THEME = 'almadar';

/** Default color mode */
export const DEFAULT_MODE = 'light' as const;
